import { useEffect, useRef } from 'react';
import { usePreferencesStore } from '../store/preferencesStore';

/**
 * The "Use Option as Meta key" preference (Settings → Extensions → Terminal,
 * macOS only in effect) for one terminal: returns a ref holding the current
 * value for the xterm constructor, and applies changes live to the open
 * xterm in `xtermRef` — no reopen. `ready` re-runs it once the xterm exists.
 */
export function useTerminalOptionAsMeta(xtermRef, ready) {
  const optionAsMeta = usePreferencesStore((s) => s.terminalOptionAsMeta === true);
  const ref = useRef(optionAsMeta);
  ref.current = optionAsMeta;

  useEffect(() => {
    const term = xtermRef.current;
    if (!term || term.options.macOptionIsMeta === optionAsMeta) return;
    term.options.macOptionIsMeta = optionAsMeta;
    term.options.macOptionClickForcesSelection = optionAsMeta;
  }, [optionAsMeta, ready, xtermRef]);

  return ref;
}
